import { CirclePerimeter } from '@/search/circlePerimeter'
import CircleSearchInput from '@/search/components/CircleSearchInput'
import { FormControl, FormLabel } from '@chakra-ui/react'
import { Visibility_Enum } from '@gql'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  singleMember?: boolean
  // ORG-02: initial perimeter for the circle picker. Defaults to "my roles"
  // since tensions/projects/decisions are usually raised in one's own role.
  defaultPerimeter?: CirclePerimeter
  // ORG-06: relayed as-is to CircleSearchInput, restricting the picker to
  // circles only (roles hidden, current value still preserved).
  circlesOnly?: boolean
  // #121: roles a tension or a project may not be carried by are greyed.
  writableOnly?: boolean
  // #121: the form's visibility, which narrows what writableOnly leaves open.
  visibility?: Visibility_Enum
}

export default function CircleFormController({
  singleMember,
  defaultPerimeter = 'myRoles',
  circlesOnly,
  writableOnly,
  visibility,
}: Props) {
  const { t } = useTranslation()
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <FormControl isInvalid={!!errors.circleId}>
      <FormLabel>{t('CircleFormController.label')}</FormLabel>
      <Controller
        name="circleId"
        control={control}
        render={({ field }) => (
          <CircleSearchInput
            singleMember={singleMember}
            defaultPerimeter={defaultPerimeter}
            circlesOnly={circlesOnly}
            disableOutsidePerimeter={writableOnly}
            writableVisibility={visibility}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </FormControl>
  )
}
